export default "__VITE_ASSET__CGBSBnow__"